module.exports = __webpack_public_path__ + "static/media/players_bg.27af4cf3.png";